import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

var _this = this,
    _jsxFileName = "/opt/build/repo/src/AccordionCollapse.tsx";

import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Collapse from './Collapse';
import AccordionContext from './AccordionContext';
import SelectableContext from './SelectableContext';
var propTypes = {
  /**
   * A key that corresponds to the toggler that triggers this collapse's expand or collapse.
   */
  eventKey: PropTypes.string.isRequired,

  /** Children prop should only contain a single child, and is enforced as such */
  children: PropTypes.element.isRequired
};
var AccordionCollapse = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      eventKey = _ref.eventKey,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "eventKey"]);

  var contextEventKey = useContext(AccordionContext); // Empty SelectableContext is to prevent elements in the collapse
  // from collapsing the accordion when clicked.

  return /*#__PURE__*/React.createElement(SelectableContext.Provider, {
    value: null,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Collapse, _extends({
    ref: ref,
    in: contextEventKey === eventKey
  }, props, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("div", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 11
    }
  }, React.Children.only(children))));
});
AccordionCollapse.propTypes = propTypes;
AccordionCollapse.displayName = 'AccordionCollapse';
export default AccordionCollapse;